import axios from "axios";
import { API_MODEBIS_CONFIG_READ_URL } from "../config";
import { RootState } from "../reducers/store";
import { createHttpHeaderWithAuthorization } from "../services/http-header";

export const GET_MODEBIS_CONFIG_START = "GET_MODEBIS_CONFIG_START";
export const GET_MODEBIS_CONFIG_SUCCESS = "GET_MODEBIS_CONFIG_SUCCESS";
export const GET_MODEBIS_CONFIG_ERROR = "GET_MODEBIS_CONFIG_ERROR";

export const getModebisConfig = () => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: GET_MODEBIS_CONFIG_START });
            axios
                .get(`${API_MODEBIS_CONFIG_READ_URL}/api/v1/config/${itemId}`, {
                    headers: dispatch(createHttpHeaderWithAuthorization(true)),
                })
                .then((result) => {
                    dispatch({
                        type: GET_MODEBIS_CONFIG_SUCCESS,
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: GET_MODEBIS_CONFIG_ERROR });
                    reject(e);
                });
        });
    };
};
